import React, { useRef, useCallback, useEffect } from 'react';
import ItemCard from './ItemCard';
import ItemCardSkeleton from './ItemCardSkeleton';
import './ItemsList.css';

const ItemsList = ({ items, lang = 'fr', dense = false, skeletonCount = 0, onLastItemVisible, onItemClick, onCardClick, onTooltipShow, onTooltipHide, preferredSlotId = null, showWeaponDamage = false, equipLabel = null, equipIcon = null, pinnedItem = null, pinnedWeaponMaging = null, pinnedItemMaging = null, onPinnedClick = null }) => {
    const observer = useRef();

    const onLastItemVisibleRef = useRef(onLastItemVisible);
    useEffect(() => {
        onLastItemVisibleRef.current = onLastItemVisible;
    }, [onLastItemVisible]);

    const lastItemRef = useCallback(node => {
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && onLastItemVisibleRef.current) {
                observer.current.disconnect();
                onLastItemVisibleRef.current();
            }
        });

        if (node) observer.current.observe(node);
    }, []);

    return (
        <div className={`items-list${dense ? ' results-list--dense' : ''}`}>
            {pinnedItem && (
                <ItemCard
                    key="pinned-equipped"
                    item={pinnedItem}
                    lang={lang}
                    dense={dense}
                    isEquipped
                    weaponMaging={pinnedWeaponMaging}
                    itemMaging={pinnedItemMaging}
                    onEquippedClick={onPinnedClick}
                    preferredSlotId={preferredSlotId}
                    showWeaponDamage={showWeaponDamage}
                    onTooltipShow={onTooltipShow}
                    onTooltipHide={onTooltipHide}
                />
            )}
            {items.map((item, index) => {
                const isLastItem = index === items.length - 1;
                // Ensure unique key by combining ID with index
                const itemId = item?.ankama_id || item?.id;
                const itemKey = itemId ? `${itemId}-${index}` : `item-${index}`;
                return <ItemCard
                    key={itemKey}
                    item={item}
                    lang={lang}
                    dense={dense}
                    onItemClick={onItemClick}
                    onCardClick={onCardClick}
                    onTooltipShow={onTooltipShow}
                    onTooltipHide={onTooltipHide}
                    preferredSlotId={preferredSlotId}
                    showWeaponDamage={showWeaponDamage}
                    equipLabel={equipLabel}
                    equipIcon={equipIcon}
                    ref={isLastItem ? lastItemRef : null}
                />
            })}
            {/* Placeholders are cells of this same grid, so they fill the row the
                pinned card started instead of opening a new one below it. */}
            {Array.from({ length: skeletonCount }, (_, i) => (
                <ItemCardSkeleton key={`skeleton-${i}`} dense={dense} />
            ))}
        </div>
    );
};

export default ItemsList;
